import React from 'react';
import { Typography } from '@mui/material';

const About: React.FC = () => {
  return (
    <div>
      <Typography variant="h3" gutterBottom component="div">
        <div>page about</div>
      </Typography>
      <Typography variant="body1">
        This is the about page where you can learn more about us.
      </Typography>
    </div>
  );
};

export default About;
